import axios from "axios";
import Encrypt from "../utils/encode";

// const baseURL = "https://mtncrn.quizmasterr.com/";
// const baseURL = "http://localhost:9085/";
const baseURL="/";

export const sendOtp = async (data) => {
    try {
        const response = await axios.post(`${baseURL}auth/sendOtp`, data);
        return response.data.message;
    } catch (e) {
        throw e.response.data;
    }
};

export const login = async (data) => {
    const response = await axios.post(`${baseURL}api/v1/login`, data);
    return response;
};

export const getFunFact = async () => {
    const response = await axios.get(`${baseURL}api/v1/fun-facts`);
    return response;
};

export const getProfile = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-user-profile`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
};

export const getAllQuiz = async (language, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-all-quizes?lang_id=${language}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
};

export const getQuiz = async (quizId, levelId, currentLanguage, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-quiz/${quizId}/${levelId}?lang_id=${currentLanguage}`, {
        timeout: 120000,
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return response;
}

export const getQuizDetails = async (quizId, levelId, currentLanguage, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-quiz/${quizId}/${levelId}?lang_id=${currentLanguage}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response?.data?.result?.data;
}

export const getLeaderboard = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-leaderboard`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const updateProfile = async (formData, token) => {
    try {
        const response = await axios.post(`${baseURL}api/v1/protected/edit-profile`, formData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data.data;
    } catch (e) {
        console.log(e);
    }
};

export const getHistory = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-history?offset=0`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const getAllOpponent = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/finding-opponent`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const saveUserPoints = async (quizId, quizName, quizImage, levelId, points, totalPoints, token) => {

    const encryptPayload = Encrypt({
        quizId: quizId,
        quizName: quizName,
        quizImage: quizImage,
        levelId: levelId,
        userPoints: points,
        totalPoints: totalPoints
    })

    const response = await axios.post(`${baseURL}api/v1/protected/save-user-points`, encryptPayload, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });
    return response;
};

export const getReverseQuizQuestions = async (level, language_id,token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-reverse-quiz-questions?level=${level}&language_id=${language_id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const saveReverseQuizPoints = async (levelId, points, totalPoints, token) => {

    const encryptPayload = Encrypt({
        levelId: levelId,
        userPoints: points,
        totalPoints: totalPoints
    })

    const response = await axios.post(`${baseURL}api/v1/protected/save-reverse-quiz-points`, encryptPayload, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });

    return response;
}

export const checkUserSubscription = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/check-user-subscription`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const saveWordGamePointsApi = async (levelId, points, totalPoints, token) => {
    const encryptPayload = Encrypt({
        levelId: levelId,
        userPoints: points,
        totalPoints: totalPoints
    })

    const response = await axios.post(`${baseURL}api/v1/protected/save-word-game-points`, encryptPayload, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });

    return response;
}

export const deletePicApi = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/delete-pic`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

const Integrated_API_URL = "https://api-mtncrn.quizmasterr.com/";

export const subscribeApi = async (msisdn, pack, extRef) => {
    const response = await axios.post(`${Integrated_API_URL}activate-user`, {
        msisdn,
        pack_type: pack,
        ext_ref: extRef
    });

    return response;
}

export const sendOtpApi = async (msisdn) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/sendOTP`, {
        msisdn
    });
    return response;
}

export const verifyOtpApi = async (msisdn, otp) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/verifyOTP`, {
        msisdn,
        otp
    });
    return response;
}

export const confirmSubAPI = async (msisdn, pack, extRef, autoRenew) => {
    const response = await axios.post(`${Integrated_API_URL}subscribe-user`, {
        msisdn: msisdn,
        pack_type: pack,
        ext_ref: extRef,
        auto_renew: autoRenew
    });
    return response;
}

export const deactivateUserApi = async (msisdn) => {
    const response = await axios.post(`${Integrated_API_URL}deactivate-user`, {
        msisdn
    });
    return response;
}

// export const unsubscribeAPI = async (msisdn) => {
//     const response = await axios.post(`${Integrated_API_URL}deactivate-user`, { msisdn });
//     return response;
// }